import { fromApiVolumeUnit, toApiVolumeUnit } from '@/utils/unitConversion';

import type {
  CreateDigitalNavigationLogFormValues,
  CreateDigitalNavigationLogRequestDto,
  DigitalNavigationLog,
  DigitalNavigationLogEntry,
  DigitalNavigationLogEntryDto,
  DigitalNavigationLogResponseDto,
  UpdateDigitalNavigationLogFormValues,
  UpdateDigitalNavigationLogRequestDto,
} from './digital-navigation-log.dto';

export const mapDigitalNavigationLogEntry = ({
  person_at_helm,
  weather_conditions,
  weather_visibility,
  wind_direction,
  wind_force,
  ...rest
}: DigitalNavigationLogEntryDto): DigitalNavigationLogEntry => ({
  ...rest,
  personAtHelm: person_at_helm,
  weatherConditions: weather_conditions,
  weatherVisibility: weather_visibility,
  windDirection: wind_direction,
  windForce: wind_force,
});

export const mapDigitalNavigationLogEntryDto = ({
  personAtHelm,
  weatherConditions,
  weatherVisibility,
  windDirection,
  windForce,
  ...rest
}: DigitalNavigationLogEntry): DigitalNavigationLogEntryDto => ({
  ...rest,
  person_at_helm: personAtHelm,
  weather_conditions: weatherConditions,
  weather_visibility: weatherVisibility,
  wind_direction: windDirection,
  wind_force: windForce,
});

export const mapDigitalNavigationLog = ({
  vessel_id,
  vessel_name,
  passage_from,
  passage_to,
  maintenance_reminders,
  fuel_taken_on_1_gals,
  fuel_taken_on_2_gals,
  water_taken_on_1_gals,
  water_taken_on_2_gals,
  volume_units,
  created_at,
  updated_at,
  entries,
  ...rest
}: DigitalNavigationLogResponseDto): DigitalNavigationLog => ({
  ...rest,
  vesselId: vessel_id,
  vesselName: vessel_name,
  passageFrom: passage_from,
  passageTo: passage_to,
  maintenanceReminders: maintenance_reminders,
  fuelTakenOn1Gals: fuel_taken_on_1_gals,
  fuelTakenOn2Gals: fuel_taken_on_2_gals,
  waterTakenOn1Gals: water_taken_on_1_gals,
  waterTakenOn2Gals: water_taken_on_2_gals,
  volumeUnit: fromApiVolumeUnit(volume_units),
  createdAt: created_at,
  updatedAt: updated_at,
  entries: (entries ?? []).map(mapDigitalNavigationLogEntry),
});

const toRfc3339 = (date: string): string => {
  const d = new Date(date.length === 10 ? `${date}T00:00:00.000Z` : date);
  return Number.isNaN(d.getTime()) ? date : d.toISOString();
};

export const mapCreateDigitalNavigationLogDto = ({
  date,
  passageFrom,
  passageTo,
  entries,
  maintenanceReminders,
  fuelTakenOn1Gals,
  fuelTakenOn2Gals,
  waterTakenOn1Gals,
  waterTakenOn2Gals,
  volumeUnit,
}: CreateDigitalNavigationLogFormValues): CreateDigitalNavigationLogRequestDto => ({
  date: toRfc3339(date),
  passage_from: passageFrom,
  passage_to: passageTo,
  entries: entries?.map(mapDigitalNavigationLogEntryDto),
  maintenance_reminders: maintenanceReminders,
  fuel_taken_on_1_gals: fuelTakenOn1Gals,
  fuel_taken_on_2_gals: fuelTakenOn2Gals,
  water_taken_on_1_gals: waterTakenOn1Gals,
  water_taken_on_2_gals: waterTakenOn2Gals,
  volume_units: toApiVolumeUnit(volumeUnit),
});

export const mapUpdateDigitalNavigationLogDto = (
  values: UpdateDigitalNavigationLogFormValues,
): UpdateDigitalNavigationLogRequestDto => ({
  ...mapCreateDigitalNavigationLogDto(values),
  id: values.id,
});
